import { validation } from "../../shared/constants/index";

// Taken from ecom _libs/validation
export function isRegonValid(value: string) {
    let digits;
    let checksum;

    if (validation.regon9chars.test(value) === true) {
        digits = value.split("");
        checksum =
            (8 * parseInt(digits[0], 10) +
                9 * parseInt(digits[1], 10) +
                2 * parseInt(digits[2], 10) +
                3 * parseInt(digits[3], 10) +
                4 * parseInt(digits[4], 10) +
                5 * parseInt(digits[5], 10) +
                6 * parseInt(digits[6], 10) +
                7 * parseInt(digits[7], 10)) %
            11;
        if (checksum === 10) {
            checksum = 0;
        }
        return parseInt(digits[8], 10) === checksum && value !== "000000000";
    } else if (validation.regon14chars.test(value)) {
        digits = value.split("");
        checksum =
            (2 * parseInt(digits[0], 10) +
                4 * parseInt(digits[1], 10) +
                8 * parseInt(digits[2], 10) +
                5 * parseInt(digits[3], 10) +
                0 * parseInt(digits[4], 10) +
                9 * parseInt(digits[5], 10) +
                7 * parseInt(digits[6], 10) +
                3 * parseInt(digits[7], 10) +
                6 * parseInt(digits[8], 10) +
                1 * parseInt(digits[9], 10) +
                2 * parseInt(digits[10], 10) +
                4 * parseInt(digits[11], 10) +
                8 * parseInt(digits[12], 10)) %
            11;
        if (checksum === 10) {
            checksum = 0;
        }
        return parseInt(digits[13], 10) === checksum && value !== "00000000000000";
    } else {
        return false;
    }
}
